module.exports = { "default": require("core-js/library/fn/symbol/iterator"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./~/babel-runtime/core-js/symbol/iterator.js
// module id = 47
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///~/babel-runtime/core-js/symbol/iterator.js